import View from "../framework/view";
import Server from "../server";
import template from "../../pugc/users";
import jQuery from "jquery";
import {User} from "../bo/user";
import {ROLE_CASUAL_DELIVERY, roles} from "../misc/types";
import {formToJson, pushHash} from "../misc/utils";
import Alerts from "../misc/alerts";
import {CasualDriverView} from "./casual_driver";


export class UsersView extends View {

    static classname = "users-view";

    private readonly server = Server.instance();

    private users : User[] | undefined;

    private edit_user? : User;

    private new_user = true;

    private casualDriver : CasualDriverView | undefined;

    constructor() {
        super(UsersView.classname);
        this.refresh();
    }

    refresh() {
        const status_ = this.server.getUsers();
        status_.then((users) => {
            this.users = users;
            this.update();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            name: (user: User) => user.role !== ROLE_CASUAL_DELIVERY ? user.username : user.displayName,
            users: this.users,
            edit_user: this.edit_user,
            new_user: this.new_user,
            roles: roles,
            casual_driver: this.casualDriver
        };

        const out = this.pug(template, data);

        out.find(".with-validation").validate({
            rules: {
                "username": "required",
            }
        })

        this.afterUpdate(() => {

            if (this.elt().data("initted")) {
                return;
            }
            this.elt().data("initted", true);

            this.elt().find("input.datefield").datefield({startDay: 1});
        });

        return out;
    }

    editUser(user: User | undefined) {
        this.new_user = ! user;

        const casual = user && user.role === ROLE_CASUAL_DELIVERY;
        if (casual) {
            this.casualDriver = new CasualDriverView(user);
        } else {
            this.casualDriver = undefined;
            this.edit_user = user || {};
        }
        this.update();
    }

    editCasualDriver(user: undefined) {
        this.elt().find(".casual-driver-editor").show();
    }

    saveUser() {
        const form = this.elt().find("form.editor");
        const user : User = {};
        formToJson(form, user);
        const save_ = this.server.saveUser(user);
        // @ts-ignore
        if ((user["password"] || user["password2"]) && (user["password"] != user["password2"])) {
            Alerts.alert("Passswords must match");
            return;
        }

        save_.then((users) => {
            this.users = users;
            this.new_user = false;
            this.edit_user = undefined;
            this.update();
        });
    }


    async saveCasualDriver() {
        const user : User = {};
        const data : any = {};
        const form = this.elt().find("form.casual-driver-editor");
        formToJson(form, data);
        user.displayName = data.driver_name;
        // @ts-ignore
        user.valid_to = data.driver_valid_to;
        if (! user.displayName) {
            Alerts.alert("You must specify a driver name");
            return;
        }

        const u = await this.server.addCasualDriver(user);

        const v = new CasualDriverView(u);
        this.casualDriver = v;
        this.update();
    }

    async viewLoad(user: User | undefined) {
        if (! user || ! user.username) {
            return;
        }
        const ids = await this.server.fetchDeliveryLoad(user.username);
        const url = `/orders/list/${ids || "none"}`;
        pushHash(url);
    }

    async clearLoad(user: User | undefined) {
        if (! user || ! user.username) {
            return;
        }
        const ids = await this.server.fetchDeliveryLoad(user.username);
        const cnt = ids ? ids.split(/,/).length : 0;
        if (cnt == 0) {
            Alerts.alert(`${user.displayName} has no orders in their load`);
        } else {
            const YES = "Yes";
            const option = await Alerts.confirmation({
                message: `Clear ${cnt} order(s) from ${user.displayName}'s load?`,
                options: [ YES, "No" ]
            });
            if (option == YES) {
                await this.server.clearDeliveryLoad(user.username);
                Alerts.alert(`Cleared ${user.displayName}'s load.`);
            }
        }
    }
}

View.on(
    "." + UsersView.classname,
    "click",
    ".add-user",
    function(that: UsersView, event, elt) {
        event.preventDefault();
        that.editUser(undefined)
    });

View.on(
    "." + UsersView.classname,
    "click",
    ".add-casual-driver",
    function(that: UsersView, event, elt) {
        event.preventDefault();
        that.editCasualDriver(undefined)
    });

View.on(
    "." + UsersView.classname,
    "click",
    ".edit",
    function(that: UsersView, event, elt) {
        event.preventDefault();
        const user = jQuery(elt).data("user") as User;
        that.editUser(user);
    });

View.on(
    "." + UsersView.classname,
    "click",
    ".view-load",
    function(that: UsersView, event, elt) {
        event.preventDefault();
        const user = jQuery(elt).data("user") as User;
        that.viewLoad(user);
    });

View.on(
    "." + UsersView.classname,
    "click",
    ".clear-load",
    function(that: UsersView, event, elt) {
        event.preventDefault();
        const user = jQuery(elt).data("user") as User;
        that.clearLoad(user);
    });

View.on(
    "." + UsersView.classname,
    "click",
    ".save-user",
    function(that: UsersView, event, elt) {
        event.preventDefault();
        that.saveUser();
    });

View.on(
    "." + UsersView.classname,
    "click",
    ".save-casual-driver",
    function(that: UsersView, event, elt) {
        event.preventDefault();
        that.saveCasualDriver();
    });

